const actions = [
  {
      title: 'Identify the behaviour you would like to start or stop.',
      text: 'Take a minute to think about the behaviour you are trying to change. Try to be really specific, [e.g. \'I am going to take a multivitamin supplement every morning\'].',
  },
  {
      title: 'Think about how you might like to record this behaviour.',
      text: 'Have a think about how, and where, you would like to record your actions. This will depend on the behaviour you would like to change - this could be something like recording daily steps on a pedometer, or making a note in a journal every time you make a healthy food substitute.',
  },
  {
      title: 'Identify what you will need to record your behaviours.',
      text: 'Depending on what method you have chosen, you may need to gather some items before you can start. This could mean buying a notebook and pen if you would like to keep a written diary, or setting up a pedometer to wear each day.',
  },
  {
      title: 'Decide when you will start keeping track of your behaviour.',
      text: 'Commit to a starting point for your recording. There\'s no time like the present, so the earlier the better! Once you\'ve set yourself a start point, try your best to keep up with your journal.',
  },
];

const tip = 'Keeping track of our behaviour change can motivate us to continue. Some days are trickier than others, so having your log to look back on can remind you how far you\'ve come already.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
